import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

declare global {
  interface Window {
    gtag_report_conversion?: (url?: string) => false;
    gtag?: (type: string, name: string, data: unknown) => void;
  }
}

if (environment.production) {
  enableProdMode();

  const DOC = document;
  const cookie = DOC.createElement('script');
  cookie.src = 'https://consent.cookiefirst.com/banner.js';
  cookie.getAttribute('data-cookiefirst-key');
  cookie.setAttribute(
    'data-cookiefirst-key',
    '29b2cf1b-fd55-464a-a0dd-b1b8756a85f3',
  );
  DOC.body.appendChild(cookie);

  const GTM = DOC.createElement('script');
  GTM.src = 'assets/js/GTM.js';
  DOC.head.appendChild(GTM);

  const fs = DOC.createElement('script');
  fs.src = 'assets/js/fastbase.js';
  DOC.head.appendChild(fs);

  const clearbit = DOC.createElement('script');
  fs.src =
    'https://tag.clearbitscripts.com/v1/pk_1f64746428c10fc93d56d4d9076700a6/tags.js';
  fs.async = true;
  fs.referrerPolicy = 'strict-origin-when-cross-origin';
  DOC.head.appendChild(clearbit);

  const reportConversion = DOC.createElement('script');
  reportConversion.src = 'assets/js/report-conversion.js';
  DOC.head.appendChild(reportConversion);
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
